// Services.jsx
import React from "react";
import { motion } from "framer-motion";

const services = [
  {
    title: "Public Health Engineering p",
    desc: [
      "Includes Design and Drawings of all following systems as per laws, National Building Code, SP-35 & relevant code.",
      "• Water supply",
      "• Drainage",
      "• Storm water systems",
      "• Rainwater harvesting",
      "• STP layouts",
      "• Hydro-pneumatic systems",
      "•Designed as per NBC and statutory norms."
    ],
    img: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80"
  },
  {
    title: "Deep Cleaning",
    desc: "End-to-end electrical engineering covering power distribution, substations, DG systems, panels, load calculations, automation integration, and energy-efficient electrical infrastructure.",
    img: "https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=600&q=80"
  },
  {
    title: "Move-In/Move-Out Cleaning",
    desc: "Routine cleaning of living spaces, including dusting, vacuuming, and surface cleaning",
    img: "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=crop&w=600&q=80"
  },
  {
    title: "Post-Construction Cleaning",
    desc: "Routine cleaning of living spaces, including dusting, vacuuming, and surface cleaning",
    img: "https://images.unsplash.com/photo-1520880867055-1e30d1cb001c?auto=format&fit=crop&w=600&q=80"
  },
  {
    title: "Carpet and Upholstery Cleaning",
    desc: "Routine cleaning of living spaces, including dusting, vacuuming, and surface cleaning",
    img: "https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=600&q=80"
  },
  {
    title: "Window Cleaning",
    desc: "Routine cleaning of living spaces, including dusting, vacuuming, and surface cleaning",
    img: "https://images.unsplash.com/photo-1482449609509-eae2a7ea42b7?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8d2luZG93JTIwY2xlYW5pbmd8ZW58MHx8MHx8fDA%3D"
  }
];

const Services = ({ noMargin }) => (
  <div style={{ background: "#111", minHeight: "100vh", padding: "40px 0" }}>
    <h1 style={{ textAlign: "center", fontWeight: 700, fontSize: 48, marginBottom: 32, color: "#fff" }}>Our services</h1>
    <div style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
      gap: 32,
      maxWidth: 1200,
      margin: "0 auto"
    }}>
      {services.map((s, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          whileHover={{ scale: 1.04, boxShadow: "0 8px 32px 0 rgba(0,0,0,0.25)" }}
          transition={{ type: "spring", stiffness: 120, damping: 18, duration: 0.6, delay: i * 0.15 }}
          style={{
            background: "#222",
            borderRadius: 40,
            padding: 32,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            minHeight: 320,
            boxShadow: "0 2px 12px 0 rgba(0,0,0,0.10)",
            cursor: "pointer",
            transition: "box-shadow 0.3s, transform 0.3s"
          }}
        >
          <div>
            <h2 style={{ fontWeight: 700, fontSize: 18, marginBottom: 12, color: "#fff" }}>{s.title}</h2>
            {Array.isArray(s.desc) ? (
              <ul style={{ fontSize: 15, color: "#fff", marginBottom: 20, paddingLeft: 20 }}>
                {s.desc.map((point, idx) => (
                  <li key={idx} style={{ marginBottom: 2 }}>{point}</li>
                ))}
              </ul>
            ) : (
              <p style={{ fontSize: 15, color: "#fff", marginBottom: 20 }}>{s.desc}</p>
            )}
          </div>
          <img src={s.img} alt={s.title} style={{ width: "100%", maxWidth: 320, borderRadius: 32, alignSelf: "center" }} />
        </motion.div>
      ))}
    </div>
  </div>
);

export default Services;
